import React, { Fragment, FunctionComponent, useRef } from "react";
import styles from "./DynamicHeading.module.scss";
import DynamicHeadingProps from "./DynamicHeadingProps.interface";

import { mergeRefs } from "react-merge-refs";
import combineClasses from "helpers/combine-classes";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import useAnimation from "blocks/hooks/useAnimation";

const DynamicHeading: FunctionComponent<DynamicHeadingProps> = (props): JSX.Element => {
    const elementRef = useRef<any>(null);

    const headlineSizeClass = props.headlineSize ? styles[props.headlineSize] : styles["H2"];
    const factor = props.factor ? props.factor : 1;

    let HeadingWeight = "h2" as keyof JSX.IntrinsicElements;
    if (props.headlineWeight) {
        HeadingWeight = props.headlineWeight.toLowerCase() as keyof JSX.IntrinsicElements;
    }

    const { animationClasses } = useAnimation(styles, "animation1");
    const { inViewElementRef, inViewClasses } = setInViewClasses(styles);

    setTimeout(() => {
        if (typeof (elementRef?.current) !== "undefined" && typeof (window) !== "undefined") {
            elementRef.current?.style?.setProperty("--adjustment-factor", factor.toString());
        }
    }, 50);

    const processedHeadline = (text: any) => {
        const parsedValue = String(text);
        const splitValues = parsedValue?.split(" ");
        const result: string[] = [];


        splitValues.forEach(splitValue => {
            result.push(`<span class="${styles.animation_wrap}"><span class="${styles.animation_inner}">${splitValue}</span></span>`);
        });

        return result.join(" ");
    };

    // TODO: Use css variables to change the value for animation1, animation2 etc.

    return (
        <Fragment>
            <HeadingWeight className={combineClasses(styles.wrapper, props.className, animationClasses, inViewClasses, headlineSizeClass)}>
                <div className={styles.adjustment} dangerouslySetInnerHTML={props.innerHTML} ref={mergeRefs([elementRef, inViewElementRef])}>
                    {props.text ? (
                        <span dangerouslySetInnerHTML={{ __html: processedHeadline(props.text) }} />
                    ) : null}

                    {props.children}
                </div>
            </HeadingWeight>
        </Fragment>
    );
};

export default DynamicHeading;